import React from "react";
import Table from "../../components/Table/Table"

const AdminReportProspects = () => {

    const columns = [
        {
            Header: "#",
            accesor: "#",
        },
        {
            Header:"Campaña",
            accesor:"Campaña",
        }
    ]

    const data = [{id:1}]

    return (
        <div className="relative flex flex-col gap-4">
            <h1>AdminReportProspects</h1>
            <Table data={data} columns={columns} />
        </div>
    );
};

export default AdminReportProspects;